import { SVGProps } from 'react';

const CaretDownIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M13.3535 6.35354L8.35354 11.3535C8.3071 11.4 8.25196 11.4369 8.19126 11.4621C8.13056 11.4872 8.0655 11.5002 7.99979 11.5002C7.93408 11.5002 7.86902 11.4872 7.80832 11.4621C7.74762 11.4369 7.69248 11.4 7.64604 11.3535L2.64604 6.35354C2.55222 6.25972 2.49951 6.13247 2.49951 5.99979C2.49951 5.86711 2.55222 5.73986 2.64604 5.64604C2.73986 5.55222 2.86711 5.49951 2.99979 5.49951C3.13247 5.49951 3.25972 5.55222 3.35354 5.64604L7.99979 10.2929L12.646 5.64604C12.6925 5.59958 12.7476 5.56273 12.8083 5.53759C12.869 5.51245 12.9341 5.49951 12.9998 5.49951C13.0655 5.49951 13.1305 5.51245 13.1912 5.53759C13.2519 5.56273 13.3071 5.59958 13.3535 5.64604C13.4 5.69249 13.4368 5.74764 13.462 5.80834C13.4871 5.86904 13.5001 5.93409 13.5001 5.99979C13.5001 6.06549 13.4871 6.13054 13.462 6.19124C13.4368 6.25193 13.4 6.30708 13.3535 6.35354Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CaretDownIcon;
